import React from 'react';
import {connect} from 'react-redux';
import {Seq} from 'immutable';

import * as ScoreType from 'constants/ScoreType';

import Score from '../Score.jsx';

class Soccer extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        scores: React.PropTypes.object,
        remark: React.PropTypes.string
    };

    render() {
        const {scores, remark} = this.props;

        const cornerScore = scores.get(ScoreType.Corner);
        const yellowCardScore = scores.get(ScoreType.YellowCard);
        const redCardScore = scores.get(ScoreType.RedCard);

        if (!cornerScore && !yellowCardScore && !redCardScore && !remark) {
            return false;
        }
        if (cornerScore && (cornerScore.get('score1') === undefined || cornerScore.get('score2') === undefined) &&
            yellowCardScore && (yellowCardScore.get('score1') === undefined ||
            yellowCardScore.get('score2') === undefined) &&
            redCardScore && (redCardScore.get('score1') === undefined || redCardScore.get('score2') === undefined) &&
            !remark) {
            return false;
        }

        return (
            <div className="event-stats">
                <div className="table">
                    <div className="row">
                        {cornerScore &&
                        <Score key={cornerScore.get('id')} score={cornerScore} spanClass="cell corners"/>}
                        {yellowCardScore &&
                        <Score key={yellowCardScore.get('id')} score={yellowCardScore} spanClass="cell yellow-cards"/>}
                        {redCardScore &&
                        <Score key={redCardScore.get('id')} score={redCardScore} spanClass="cell red-cards"/>}
                    </div>
                </div>
                {remark && <div className="event-comments">{remark}</div>}
            </div>
        );
    }
}

function select(state, props) {
    const scoresStore = state.application.getIn([props.section, 'scores']);
    const scores = Seq(props.scores).map((id) => scoresStore.get(id));

    return {
        ...props,
        scores
    };
}

export default connect(select)(Soccer);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/matchStats/sports/Soccer.jsx